import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
    SET_MISCELLANEOUS_REPORT,
    SAVE_MISCELLANEOUS,
    UP_DATA_INITIAL,
    GET_MISCELLANEOUS,
    SUBMIT_MISCELLANEOUS,
} from 'store/key';
import { produce } from 'utility/general';
import { setGlobalLoading } from 'store/global/reducer';
import API from 'api/call';
import { safeSaga } from 'store';
import store from 'store';
import { setGlobal } from 'store/global/reducer';
import { statusLookup } from 'utility/lookup';

const initialState = {
    reportData: null,
    remoteDetail: {
        actualStudyStartDate: null,
        isNotYetStarted: false,
        addSupplements: [],
        deleteSupplements: [],
        listOfSubmittedInformation: null,
        remarkOfOthers: null,
        typeOfSubmittedInformation: null,
        signedFileName: '',
        signedFileId: '',
    },
    rows: [],
    remoteDocIds: [],
    isLoading: false,
    forceErrorDisplay: false,
    oldData: {
        actualStudyStartDate: null,
        isNotYetStarted: false,
        listOfSubmittedInformation: null,
        remarkOfOthers: null,
        typeOfSubmittedInformation: null,
    },
};
function* upDataInitial(action) {
    const { key, value } = action.payload;
    const { miscellaneousReport } = yield select();
    miscellaneousReport[key] = value;
    yield put({
        type: SET_MISCELLANEOUS_REPORT,
        payload: miscellaneousReport,
    });
}

function* getMiscellaneous(action) {
    const { docType, reportId, appId, isFormCreate, siteId, onPermissionError } = action.payload;
    const { miscellaneousReport } = yield select();
    miscellaneousReport.isLoading = true;
    miscellaneousReport.forceErrorDisplay = false;
    yield put({
        type: SET_MISCELLANEOUS_REPORT,
        payload: miscellaneousReport,
    });

    try {
        let data = { docType: docType };
        if (isFormCreate) {
            data.appId = parseInt(appId);
            data.reportId = null;
            if (siteId) {
                data.siteId = parseInt(siteId);
            }
        } else {
            data.reportId = parseInt(reportId);
        }

        const res = yield call(API.postApprovalActivities.getReportDetail, data);
        const detail = res.data.result;

        miscellaneousReport.remoteDetail = detail;
        miscellaneousReport.remoteDetail.addSupplements = [];
        miscellaneousReport.remoteDetail.deleteSupplements = [];
        miscellaneousReport.rows = detail.supplementDocuments ?? [];
        miscellaneousReport.remoteDocIds = detail.supplementDocuments?.map((item) => item.id) ?? [];

        miscellaneousReport.oldData.actualStudyStartDate = detail.actualStudyStartDate;
        miscellaneousReport.oldData.isNotYetStarted = detail.isNotYetStarted;
        miscellaneousReport.oldData.listOfSubmittedInformation = detail.listOfSubmittedInformation;
        miscellaneousReport.oldData.remarkOfOthers = detail.remarkOfOthers;
        miscellaneousReport.oldData.typeOfSubmittedInformation = detail.typeOfSubmittedInformation;

        if (detail.typeOfSubmittedInformation === 'B') {
            miscellaneousReport.remoteDetail.typeOfSubmittedInformation = 'newInformation,others';
            miscellaneousReport.oldData.typeOfSubmittedInformation = 'newInformation,others';
        }
        if (detail.typeOfSubmittedInformation === 'N' || detail.typeOfSubmittedInformation === 'null') {
            miscellaneousReport.remoteDetail.typeOfSubmittedInformation = 'newInformation';
            miscellaneousReport.oldData.typeOfSubmittedInformation = 'newInformation';
        }
        if (detail.typeOfSubmittedInformation === 'O') {
            miscellaneousReport.remoteDetail.typeOfSubmittedInformation = 'others';
            miscellaneousReport.oldData.typeOfSubmittedInformation = 'others';
        }

        if (detail.isNotYetStarted === null) {
            miscellaneousReport.remoteDetail.isNotYetStarted = false;
        }

        if (!isFormCreate) {
            let subNo = null,
                statusDisplay = null;
            if (detail.subNo) {
                subNo = detail.subNo;
            }
            if (detail.lastStatus !== null) {
                statusDisplay =
                    statusLookup.find((item) => {
                        return detail.lastStatus === item.key;
                    })?.statusDisplay || null;
            }
            store.dispatch(
                setGlobal({
                    postApprovalReportData: {
                        [reportId]: {
                            showNavigationSubNo: subNo,
                            showNavigationStatus: statusDisplay,
                        },
                    },
                }),
            );
        }
    } catch (error) {
        console.log('%c 150909 reducer.js error', 'background: green', error)
        return onPermissionError?.();
    }

    miscellaneousReport.isLoading = false;

    yield put({
        type: SET_MISCELLANEOUS_REPORT,
        payload: miscellaneousReport,
    });
}

function* saveMiscellaneous(action) {
    const { callback, reportId, appId, isFormCreate, signedFileId, siteId } = action.payload;
    const { miscellaneousReport } = yield select();
    setGlobalLoading(true);
    try {
        const {
            actualStudyStartDate,
            isNotYetStarted,
            addSupplements,
            deleteSupplements,
            listOfSubmittedInformation = null,
            remarkOfOthers = null,
            typeOfSubmittedInformation,
        } = miscellaneousReport.remoteDetail;

        let data = {
            actualStudyStartDate: actualStudyStartDate ? new Date(actualStudyStartDate) : null,
            isNotYetStarted,
            addSupplements,
            deleteSupplements,
            listOfSubmittedInformation,
            remarkOfOthers,
            typeOfSubmittedInformation,
            appId: appId ?? miscellaneousReport.remoteDetail.appId,
            signedFileId,
        };

        if (siteId) {
            data.siteId = parseInt(siteId);
        }

        if (!isFormCreate) {
            data.reportId = reportId;
        }

        if (isNotYetStarted === null) {
            data.isNotYetStarted = false;
        }

        if (typeOfSubmittedInformation === null) {
            data.typeOfSubmittedInformation = 'N';
        } else {
            if (!typeOfSubmittedInformation.includes('others')) {
                data.remarkOfOthers = null;
                data.typeOfSubmittedInformation = 'N';
            }

            if (!typeOfSubmittedInformation.includes('newInformation')) {
                data.typeOfSubmittedInformation = 'O';
            }

            if (
                typeOfSubmittedInformation.includes('others') &&
                typeOfSubmittedInformation.includes('newInformation')
            ) {
                data.typeOfSubmittedInformation = 'B';
            }
        }

        console.log('reduce data', data);
        const res = yield call(API.miscellaneousReport.saveMiscellaneous, data);

        const newReportId = res.data.result.reportId;
        callback?.(newReportId);
    } catch (error) {
        console.log('create/save miscellaneous failed:', error);
    }
    setGlobalLoading(false);
}

function* submitMiscellaneous(action) {
    const { callback, reportId, appId, isFormCreate, signedFileId, siteId } = action.payload;
    const { miscellaneousReport } = yield select();
    setGlobalLoading(true);
    try {
        const {
            actualStudyStartDate,
            isNotYetStarted,
            addSupplements,
            deleteSupplements,
            listOfSubmittedInformation,
            remarkOfOthers,
            typeOfSubmittedInformation,
        } = miscellaneousReport.remoteDetail;

        let data = {
            actualStudyStartDate: actualStudyStartDate ? new Date(actualStudyStartDate) : null,
            isNotYetStarted,
            addSupplements,
            deleteSupplements,
            listOfSubmittedInformation,
            remarkOfOthers,
            typeOfSubmittedInformation,
            appId: appId ?? miscellaneousReport.remoteDetail.appId,
            signedFileId,
        };

        if (isNotYetStarted === null) {
            data.isNotYetStarted = false;
        }

        if (siteId) {
            data.siteId = parseInt(siteId);
        }

        if (!isFormCreate) {
            data.reportId = parseInt(reportId);
        }

        if (typeOfSubmittedInformation === null) {
            data.typeOfSubmittedInformation = 'N';
        } else {
            if (!typeOfSubmittedInformation.includes('others')) {
                data.remarkOfOthers = null;
                data.typeOfSubmittedInformation = 'N';
            }

            if (!typeOfSubmittedInformation.includes('newInformation')) {
                data.typeOfSubmittedInformation = 'O';
            }

            if (
                typeOfSubmittedInformation.includes('others') &&
                typeOfSubmittedInformation.includes('newInformation')
            ) {
                data.typeOfSubmittedInformation = 'B';
            }
        }

        console.log('submit reducer', data);

        try {
            const response = yield call(API.miscellaneousReport.submitMiscellaneous, data);
            if (response.status === 400) {
                throw new Error('Bad Request: The server returned a 400 status.');
            }
            callback?.();
        } catch (error) {
            console.log('submit miscellaneous failed:', error);
            throw error; // Re-throw the error if needed
        }

        // const newReportId = res.data.result.reportId;
        callback?.();
    } catch (error) {
        console.log('submit miscellaneous failed:', error);
    }
    setGlobalLoading(false);
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_MISCELLANEOUS_REPORT:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};
export function* watchMiscellaneousReport() {
    yield takeEvery(UP_DATA_INITIAL, safeSaga(upDataInitial));
    yield takeEvery(GET_MISCELLANEOUS, safeSaga(getMiscellaneous));
    yield takeEvery(SAVE_MISCELLANEOUS, safeSaga(saveMiscellaneous));
    yield takeEvery(SUBMIT_MISCELLANEOUS, safeSaga(submitMiscellaneous));
}

export default reducer;
